import "intl-pluralrules";
import "expo-router/entry";
import "react-native-get-random-values";
